import { Language } from '../../dto/language';
import { TranslationMode } from '../../dto/translation-mode';
import { NewsCategoryResponse } from '../../dto/categories';
import { MakeReactive, noopMakeReactive } from '../make-reactive';
import { INewsContentService } from '../../services/i-news-content-service';

export abstract class ICategoriesLoader {
	protected constructor(
		protected readonly service: INewsContentService,
		protected readonly sourceLang: Language,
		protected readonly targetLang: Language,
		protected readonly mode: TranslationMode,
		protected readonly makeReactive: MakeReactive<unknown> = noopMakeReactive
	) {}

	abstract isLoading(): boolean;
	abstract loadCategories(): Promise<void>;
	abstract get categories(): NewsCategoryResponse['categories'];
	abstract get userCategories(): NewsCategoryResponse['userCategories'];
	abstract get error(): string;
	abstract clearCache(): void;
}


